import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseInvoiceItemPriceShouldNotBeLessThanZero extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.items.price.cannot-be-less-than-zero');
    }
}
